import providerLogo from './provider-logo.png';
import patientLogo from './patient-logo.png'

export const images = {
    providerLogo, patientLogo
}